(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/spelpaus/assets/javascripts/models/suspension.js') >= 0) return;  svs.modules.push('/modules/spelpaus/assets/javascripts/models/suspension.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.spelpaus.models.Suspension = Backbone.Model.extend({
    defaults: {
      product: undefined,
      period: 0,
      validFrom: undefined,
      validTo: undefined,
      ended: undefined,
      periodText: undefined
    },
    parse: function(data) {
      var period = Math.max(data.period || 0, data.terminationPeriod || 0, data.termination || 0);
      return _.extend(
        {},
        {
          product: data.product,
          period: period,
          validFrom: data.validFrom,
          validTo: data.validTo,
          terminable: data.terminable,
          ended: data.ended,
          periodText: period === 0 ? '' : period < 12 ? period + ' månader' : period / 12 + ' år'
        }
      );
    }
  });
})(Backbone, _, svs);

 })(window);